var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2526 1.4974C13.0825 2.32726 13.0825 3.67274 12.2526 4.5026L5.2552 11.5L12.2526 18.4974C13.0825 19.3273 13.0825 20.6727 12.2526 21.5026C11.4227 22.3325 10.0773 22.3325 9.2474 21.5026L0.747398 13.0026C-0.0824661 12.1727 -0.0824661 10.8273 0.747398 9.9974L9.2474 1.4974C10.0773 0.667534 11.4227 0.667534 12.2526 1.4974Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.24701858ed93e5f33006daa617975596.svg";
export { ForwardRef as ReactComponent };